// extracted by mini-css-extract-plugin
export var root = "fc-updates-module--root--c4d6c";
export var text = "fc-updates-module--text--55702";
export var title = "fc-updates-module--title--a456d";
export var white = "fc-updates-module--white--b9873";